import React from 'react';
import { Routes, Route } from 'react-router-dom';
import QuoteForm from './components/QuoteForm';
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';
import SubmissionDetail from './components/SubmissionDetail';

function App() {
  return (
    <div className="app-container">
      <Routes>
        <Route path="/" element={<QuoteForm />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/submission/:id" element={<SubmissionDetail />} />
      </Routes>
    </div>
  );
}

export default App;
